(function () {
  function closeAccountDropdown(dropdown, trigger) {
    if (!dropdown) return;
    dropdown.classList.remove('active');
    dropdown.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllAccountDropdowns() {
    document.querySelectorAll('[data-account-dropdown].active').forEach(function (dropdown) {
      closeAccountDropdown(dropdown, dropdown._accountTrigger || null);
    });
  }

  function closeSearchLayers() {
    document.querySelectorAll('.heathen-search-layer[aria-hidden="false"]').forEach(function (layer) {
      layer.setAttribute('aria-hidden', 'true');
    });
  }

  function closeCartLayers() {
    document.querySelectorAll('[data-cart-dropdown].active').forEach(function (dropdown) {
      dropdown.classList.remove('active');
      dropdown.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-cart-trigger][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function closeSubmenuLayers() {
    document.querySelectorAll('.heathen-submenu-panel.show').forEach(function (panel) {
      panel.classList.remove('show');
      panel._heathenNavRoot = null;
    });
    document.querySelectorAll('.heathen-navigation__top-link[aria-expanded="true"]').forEach(function (link) {
      link.setAttribute('aria-expanded', 'false');
    });
  }

  function mountDropdown(wrapper) {
    var dropdown = wrapper._heathenAccountDropdown || wrapper.querySelector('[data-account-dropdown]');
    var header = wrapper.closest('.custom-header');
    var host = (header && header.parentElement) || document.body;
    if (!dropdown || !host) return dropdown;
    if (dropdown.parentElement !== host) host.appendChild(dropdown);
    return dropdown;
  }

  function updateAccountMenuState(wrapper, dropdown) {
    var isLoggedIn = wrapper.getAttribute('data-account-logged-in') === 'true';
    var auth = dropdown.querySelector('.account-auth');
    var guest = dropdown.querySelector('.account-guest');
    if (!auth || !guest) return;

    if (isLoggedIn) {
      auth.style.display = '';
      guest.style.display = 'none';
      guest.classList.remove('active');
    } else {
      auth.style.display = 'none';
      guest.style.display = '';
      guest.classList.add('active');
    }
  }

  function bindAccount(wrapper) {
    if (!wrapper || wrapper.dataset.heathenAccountBound === '1') return;
    wrapper.dataset.heathenAccountBound = '1';

    var trigger = wrapper.querySelector('[data-account-trigger]');
    var dropdown = wrapper.querySelector('[data-account-dropdown]');
    if (!trigger || !dropdown) return;

    wrapper._heathenAccountDropdown = dropdown;
    dropdown._accountTrigger = trigger;
    mountDropdown(wrapper);
    updateAccountMenuState(wrapper, dropdown);

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      dropdown = mountDropdown(wrapper) || dropdown;
      var isVisible = dropdown.classList.contains('active');

      if (isVisible) {
        closeAccountDropdown(dropdown, trigger);
        return;
      }

      closeAllAccountDropdowns();
      closeSearchLayers();
      closeCartLayers();
      closeSubmenuLayers();
      updateAccountMenuState(wrapper, dropdown);
      dropdown.classList.add('active');
      dropdown.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    });

    document.addEventListener('click', function (event) {
      var container = wrapper._heathenAccountDropdown || dropdown;
      if (!container || !container.classList.contains('active')) return;
      var insideTrigger = wrapper.contains(event.target);
      var insideDropdown = container.contains(event.target);
      if (!insideTrigger && !insideDropdown) closeAccountDropdown(container, trigger);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var container = wrapper._heathenAccountDropdown || dropdown;
      if (!container || !container.classList.contains('active')) return;
      closeAccountDropdown(container, trigger);
    });

    var loginBtn = dropdown.querySelector('[data-action="go-login"]');
    var registerBtn = dropdown.querySelector('[data-action="go-register"]');

    var loginUrl = dropdown.getAttribute('data-login-url') || '/account/login';
    var registerUrl = dropdown.getAttribute('data-register-url') || '/account/register';

    if (loginBtn) {
      loginBtn.addEventListener('click', function () {
        window.location.href = loginUrl;
      });
    }

    if (registerBtn) {
      registerBtn.addEventListener('click', function () {
        window.location.href = registerUrl;
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-heathen-account]').forEach(bindAccount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-heathen-account]').forEach(bindAccount);
  });
})();
